/**
 * Set title of the page
 * @param {string=} title 
 */
export const setTitle = (title) => document.title = title ? `${title} - ${process.env.REACT_APP_SHORT_NAME}` : process.env.REACT_APP_SHORT_NAME